// eslint-disable-next-line
// if (__DEV__) {
//     // eslint-disable-next-line
//     import("./ReactotronConfig").then(() => console.log("Reactotron Configured"));
// }
import { registerRootComponent } from "expo";
import App from "./App";
registerRootComponent(App);
